import styled from "styled-components";

// Public pages keep their own look whatever the user's color scheme
const publicPageBackgrounds = {
  login: "#121212",
  previews: "#EFEFEC",
};

export const BackgroundApp = styled.div`
  background-color: ${({ $publicPage }) => publicPageBackgrounds[$publicPage] ?? "var(--dp-bg)"};
  color: var(--dp-text);
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${({ $publicPage }) => ($publicPage === "previews" ? "0" : "16px")};
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;
